<template>
  <div v-if="embedded" class="col-12 refine-search-filter-embedded">
    <RefineSearchMultiCheckboxButton
      class="q-mb-sm"
      full-width-on-mobile
      label="Fuel type"
      :options="fuelTypeOptions"
      v-model="localSelectedFuelType"
      :disabled="disabled || isFetchRatebookLoading"
    />
  </div>
  <CustomExpansionItem v-else class="col-12 q-mb-sm" label="Fuel type" v-model="isOpen">
    <RefineSearchMultiCheckboxButton
      class="q-mb-sm"
      full-width-on-mobile
      :options="fuelTypeOptions"
      v-model="localSelectedFuelType"
      :disabled="disabled || isFetchRatebookLoading"
    />
  </CustomExpansionItem>
</template>

<script>
import CustomExpansionItem from '../CustomExpansionItem';
import RefineSearchMultiCheckboxButton from './RefineSearchMultiCheckboxButton';

export default {
  name: 'FuelTypeFilterSection',
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    fuelTypeOptions: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isFetchRatebookLoading: {
      type: Boolean,
      default: false
    },
    embedded: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isOpen: false,
      localSelectedFuelType: { ...this.value },
      isSyncingFromProp: false
    };
  },
  watch: {
    value(newValue) {
      // Prevent circular updates - only sync if different
      if (!this.isSyncingFromProp) {
        this.isSyncingFromProp = true;
        this.localSelectedFuelType = { ...newValue };
        this.$nextTick(() => {
          this.isSyncingFromProp = false;
        });
      }
    },
    localSelectedFuelType: {
      handler(newValue) {
        // Only emit if change came from user interaction, not prop sync
        if (!this.isSyncingFromProp) {
          this.$emit('input', newValue);
          this.$emit('change');
        }
      },
      deep: true
    }
  },
  components: {
    CustomExpansionItem,
    RefineSearchMultiCheckboxButton
  }
};
</script>
